import React, { Component } from "react";
import "../App.css";
import HobbiesBanner from "../images/Hobbies/hobbies-banner.png";
import CloseArrow from "../images/close_arrow.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Hobbies extends Component {
  state = {
    bookList: [
      {
        id: 1,
        title: "The Power of Positive Thinking",
        author: "Norman Vincent Peale",
        preview:
          "In this best seller the author depicts the power of faith and action. The author illustrates key steps to creating a better life, such as changing your expectation, belief,development, breaking habits, improving professional relationships etc.",
      },
      {
        id: 2,
        title: "The Elephant in the Brain",
        author: "Kevin Simler, Robin Hanson",
        preview:
          "The main premise of this is to uncover the motive behind people's actions, the good, bad and the ugly. Once discovered people can take the time to understand and better themselves. Unconscious behavior are the main drivers of institutions in society, and hidden motives contribute to the downfall or advancement of a society; confronting the elephant brain can change the way you see yourself and society.",
      },
      {
        id: 3,
        title: "Atomic Habits",
        author: "James Clear",
        preview:
          "This book is for someone who has problems changing their habits. This book was written by James Clear, a “thought leader” known for helping people change their habits. Clear, breaks down the problem in changing your habits and teaches you how to create new ones.",
      },
      {
        id: 4,
        title: "The Power of Now",
        author: "Eckhort Tolle",
        preview:
          "This book is a guide to enlightenment and  shows techniques on how to achieve mindfulness.",
      },
      {
        id: 5,
        title: "Practicing Mindfulness",
        author: "Matthew Sockolov",
        preview:
          "Practicing Mindfulness was created by the founder of One Mind Dharma. He developed these 75 essential exercises to offer practical guidance for anyone who wants to realize the benefits of mindful meditation.",
      },
      {
        id: 6,
        title: "Habit Stacking",
        author: "SJ Scott",
        preview:
          "We all know it's not easy to add multiple new habits to your day. But what you might not realize is it's fairly easy to build a single new routine. The essence of habit stacking is to take a series of small changes and create a ritual that you follow on a daily basis.",
      },
      {
        id: 7,
        title: "The Magic of Thinking Big",
        author: "David Schwartz",
        preview:
          "The Magic of Thinking Big gives you useful methods, not empty promises. Dr. Schwartz presents a carefully designed program for getting the most out of your job, your marriage and family life, and your community.",
      },
      {
        id: 8,
        title: "Over Thinking",
        author: "John Tracy",
        preview:
          "Have you ever felt that your head was on the verge of exploding? Is your mind foggy and unable to focus? Are thoughts running through your mind like a crazy train without brakes? It’s terrible, I know…but there is a solution! Keep reading.",
      },
    ],
  };

  handleBook1Click = () => {
    document
      .getElementById("bump-out-1")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook2Click = () => {
    document
      .getElementById("bump-out-2")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook3Click = () => {
    document
      .getElementById("bump-out-3")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook4Click = () => {
    document
      .getElementById("bump-out-4")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook5Click = () => {
    document
      .getElementById("bump-out-5")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook6Click = () => {
    document
      .getElementById("bump-out-6")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook7Click = () => {
    document
      .getElementById("bump-out-7")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook8Click = () => {
    document
      .getElementById("bump-out-8")
      .classList.toggle("bump-out-slide-left");
  };

  render() {
    return (
      <div>
        <section className="time-banner-wrapper">
          <img
            className="Time-Banner"
            src={HobbiesBanner}
            alt="timebanner"
          ></img>
          <div>
            <h1>Hobbies and Habits</h1>
            <p>
              Hobbies are great distractions from the worries and troubles that
              plague daily living
            </p>
          </div>
        </section>
        <section className="time-grid-container">
          <div className="grid-title">
            <h1>Popular Titles</h1>
            <input type="search" placeholder="search titles"></input>
          </div>

          {/* Book 1 */}
          <div className="bumpout-animation-wrapper book-1-position">
            <div id="bump-out-1" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[0].title}</h2>
                <h2>Author: {this.state.bookList[0].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[0].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook1Click}
              />
            </div>
            <div
              className="hobbies-book1-cover book1-style"
              onClick={this.handleBook1Click}
            ></div>
          </div>

          {/* Book 2 */}
          <div className="bumpout-animation-wrapper book-2-position">
            <div id="bump-out-2" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[1].title}</h2>
                <h2>Author: {this.state.bookList[1].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[1].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook2Click}
              />
            </div>
            <div
              className="hobbies-book2-cover book2-style"
              onClick={this.handleBook2Click}
            ></div>
          </div>

          {/* Book 3 */}
          <div className="bumpout-animation-wrapper book-3-position">
            <div id="bump-out-3" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[2].title}</h2>
                <h2>Author: {this.state.bookList[2].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[2].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook3Click}
              />
            </div>
            <div
              className="hobbies-book3-cover book3-style"
              onClick={this.handleBook3Click}
            ></div>
          </div>

          {/* Book 4 */}
          <div className="bumpout-animation-wrapper book-4-position">
            <div id="bump-out-4" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[3].title}</h2>
                <h2>Author: {this.state.bookList[3].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[3].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook4Click}
              />
            </div>
            <div
              className="hobbies-book4-cover book4-style"
              onClick={this.handleBook4Click}
            ></div>
          </div>

          {/* Book 5 */}
          <div className="bumpout-animation-wrapper book-5-position">
            <div id="bump-out-5" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[4].title}</h2>
                <h2>Author: {this.state.bookList[4].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[4].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook3Click}
              />
            </div>
            <div
              className="hobbies-book5-cover book5-style"
              onClick={this.handleBook5Click}
            ></div>
          </div>

          {/* Book 6 */}
          <div className="bumpout-animation-wrapper book-6-position">
            <div id="bump-out-6" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[5].title}</h2>
                <h2>Author: {this.state.bookList[5].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[5].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook4Click}
              />
            </div>
            <div
              className="hobbies-book6-cover book6-style"
              onClick={this.handleBook6Click}
            ></div>
          </div>

          {/* Book 7 */}
          <div className="bumpout-animation-wrapper book-7-position">
            <div id="bump-out-7" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[6].title}</h2>
                <h2>Author: {this.state.bookList[6].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[6].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook7Click}
              />
            </div>
            <div
              className="hobbies-book7-cover book7-style"
              onClick={this.handleBook7Click}
            ></div>
          </div>

          {/* Book 8 */}
          <div className="bumpout-animation-wrapper book-8-position">
            <div id="bump-out-8" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[7].title}</h2>
                <h2>Author: {this.state.bookList[7].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[7].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook8Click}
              />
            </div>
            <div
              className="hobbies-book8-cover book8-style"
              onClick={this.handleBook8Click}
            ></div>
          </div>
        </section>
      </div>
    );
  }
}

export default Hobbies;
